// import external dependencies
import 'jquery';

// Import everything from autoload


// import local dependencies
import './partials/am2-ajax.js';
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import singleCourses from './routes/singleCourses';
import archive from './routes/archive';
import search from './routes/search';


//import 'aframe/build/aframe.js';
import './cutup/pannellum.js';
import './cutup/bootstrap.min.js';
import './cutup/slick.min.js';
import './cutup/jquery.matchHeight-min.js';
import './cutup/jquery.mmenu.min.all.js';
import './cutup/bootstrap-select.min.js';
import './cutup/jquery.magnific-popup.min.js';
import './cutup/jquery-dynamicNumber.min.js';
import './cutup/appear.min.js';
import './cutup/scripts.js';
import 'jquery-serializejson/jquery.serializejson.min.js';



/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
  // Single Course
  singleCourses,
  // Archive Courses
  archive,
  // Main site search
  search,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js